<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f7f8fa;
  color: #333;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

#app {
  width: 100%;
  min-height: 100vh;
}

:root {
  --primary-color: #f95d53;
  --text-color: #333;
  --background-color: #f7f8fa;
  --border-color: #eee;
}

/* 全局Vant组件风格定制 */
:root:root {
  --van-primary-color: var(--primary-color);
  --van-button-primary-background: var(--primary-color);
  --van-button-primary-border-color: var(--primary-color);
  --van-tabs-bottom-bar-color: var(--primary-color);
}

/* 全局输入框样式定制 */
input, textarea {
  font-size: 16px !important; /* 防止iOS自动放大 */
}

/* 全局设置vant输入框右对齐 */
.van-field__control {
  text-align: right !important;
}

/* 自动禁用用户缩放 */
@media screen and (max-width: 768px) {
  input, select, textarea {
    font-size: 16px !important;
  }
}
</style>
